/* Local dependecies */
import { User } from '../../types';
import { GetUser, GetUserActionTypes, GetUserSuccess } from './types';

export function getUser(userId: string): GetUser {
  return {
    type: GetUserActionTypes.GET_USER_REQUEST,
    userId,
  };
}

export function getUserSuccess(user: User): GetUserSuccess {
  return {
    type: GetUserActionTypes.GET_USER_SUCCESS,
    user,
  };
}

export function getUserError(error: Error) {
  return {
    type: GetUserActionTypes.GET_USER_ERROR,
    error,
  };
}
